import { makeStyles } from '@material-ui/core/styles';

export const styles = makeStyles((theme) => ({
  root: {
    maxWidth: '100wv',
    padding: 0,
    height: '90vh',
    margin: '0 auto',
  },
  programDetailsInfo: {
    textAlign: 'left',
    margin: '10px 0',
    height: '100px',
  },
  programMoreDetails: {
    textAlign: 'left',
    margin: '10px 0',
    height: '75%',
  },
  programName: {
    fontSize: '1.6rem',
  },
  programDetailsTags: {
    float: 'left',
    width: '25%',
  },
  programDetailsOwner: {
    width: '70%',
    float: 'right',
    margin: '10px',
    '& .MuiTypography-root': {
      fontSize: '14px !important',
      fontWeight: 'bold !important',
    },
    display: 'inline-flex',
    alignItems: 'center',
  },
  ownerImage: {
    display: 'inline-block',
    right: '20px !important',
    width: '20px',
    height: '20px',
    lineHeight: '20px',
    fontWeight: 'normal',
    fontSize: '10px',
    margin: '0 3px 0 10px',
  },
  backToProgramsLink: {
    textAlign: 'left',
    marginLeft: '30px 0',
  },
  overrides: {
    '& .MuiTabs-scroller': {
      backgroundColor: '#ddd',
    },
  },
}));
